import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Banner } from 'src/@omnial/_models/catalog/banner.model';
import { Slider } from 'src/@omnial/_models/catalog/slider.model';
import { SevenSpikesService } from 'src/@omnial/_services/catalog/seven.spikes.service';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-banners-static',
    templateUrl: './../../../app/shared/banners-static/banners-static.component.html',
    styleUrls: ['./../../../app/shared/banners-static/banners-static.component.scss'],
    standalone: false
})
export class BannersStaticComponent implements OnInit, OnDestroy {
  @Input() widgetZone: string;
  @Input() slug: string;
  @Input() contentClass: string = '';
  public banners: Banner[];
  public subscriptions: Subscription[] = [];

  constructor(private sevenSpikesService: SevenSpikesService, public router: Router, public settings: AppSettings) { }

  ngOnInit(): void {
    if (this.widgetZone) {
      this.getSlides(this.widgetZone, this.slug);
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  public getSlides(widgetZone: string, slug: string): void {
    this.subscriptions.push(this.sevenSpikesService.getSlides(widgetZone, slug).subscribe(
      data => {
        const sliders = data as Slider[];
        if (sliders?.length > 0) {
          const slider = sliders[0]; // We are only interested in one slider so use the first
          this.banners = new Array<Banner>();
          if (slider.slides) {
            slider.slides.forEach(slide => {
              if (slide.visible) {
                this.banners.push(this.sevenSpikesService.banner(slide));
              }
            });
          }
        }
      }));
  }

  public bannerLink(url: string): void {
    if (url && url !== null) {
      this.router.navigate([url]);
    }
  }
}
